/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.HomePage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the HomePage container!',
  },
  noOfferFound: {
    id: `${scope}.noOfferFound`,
    defaultMessage: `Oops, al momento non abbiamo risultati per la tua ricerca.
    <br />
    Prova a modificare o a cancellare i filtri selezionati.`,
  },
});
